/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import _ from 'lodash';

function createSystemField(key, name) {
  return {
    name: name,
    required: false,
    key: key,
    schema: {
      type: key,
      system: key,
    },
  };
}

export function transformIssueFields(issueFields) {
  return _.values(issueFields);
}

export function getAllIssueFields(issueFields) {
  const issueFieldsValues = transformIssueFields(issueFields);

  return [
    createSystemField('status', 'Status'),
    createSystemField('resolution', 'Resolution'),
    createSystemField('reporter', 'Reporter'),
    createSystemField('created', 'Created'),
    createSystemField('updated', 'Updated'),
    createSystemField('resolutiondate', 'Resolved'),
    createSystemField('votes', 'Votes'),
    createSystemField('watches', 'Watchers'),
    ...issueFieldsValues,
  ];
}

export function isFieldTitleCopiable(field) {
  return field.schema.custom === 'com.pyxis.greenhopper.jira:gh-epic-label';
}
